export default "__VITE_ASSET__CveiRBUd__"